// Instagram партнёра карты: из того, что человек вписал, — только ник.
//
// Случай 14.10.2026: в поле вписали «Gulay muellim_» (имя вместо ника), и
// ссылку из такого не построить. Поэтому в анкете проверяем, а в базу и на
// страницу профиля идёт только чистый ник. Принимаем «@ник», «ник», ссылку
// instagram.com/ник (с https, www, хвостом /? и параметрами).
// Чистая функция — её зовут форма, сервер и scripts/verify-tutor-join-ux.mts.

/** Ник Instagram: латиница, цифры, точка и подчёркивание, до 30 знаков. */
export const INSTAGRAM_RE = /^[A-Za-z0-9._]{1,30}$/;

/**
 * Ник из ввода. "" — поле пустое (оно необязательное), null — ввод есть, но
 * ника из него не получилось (пробел внутри, кириллица, чужой сайт).
 */
export function normalizeInstagram(raw: string | null | undefined): string | null {
  let s = (raw ?? "").trim();
  if (!s) return "";
  // Ссылка: срезаем схему, www и домен; дальше — первый сегмент пути.
  const link = s.match(
    /^(?:https?:\/\/)?(?:www\.|m\.)?(?:instagram\.com|instagr\.am)\/+([^/?#]*)/i,
  );
  if (link) s = link[1];
  else if (/^(?:https?:\/\/)|\//i.test(s) || /\.[a-z]{2,}\//i.test(s)) return null;
  // Пробелы по краям — прочь; пробел ВНУТРИ — это имя, а не ник («Gulay
  // muellim_»): склеивать нельзя, получится чужой аккаунт.
  s = s.replace(/^@+/, "").trim();
  return INSTAGRAM_RE.test(s) ? s : null;
}

/** Ссылка на профиль по нику; кривой ник — null (ссылки нет). */
export function instagramHref(nick: string | null | undefined): string | null {
  const n = normalizeInstagram(nick);
  return n ? `https://instagram.com/${n}` : null;
}
